import { queryClient, useMutation } from '../../../../ReactQuery';
import { put } from '../../../../redux/api';
import type { TeamGroupResponse, UpdateTeamGroupRequest } from '../../../../../shared/types/routes/teamGroups';

import { getTeamGroupQueryKey } from './useTeamGroup';

//  Function to update a team group
function updateTeamGroup(teamGroup: UpdateTeamGroupRequest) {
  return put<UpdateTeamGroupRequest, TeamGroupResponse>(`/api/teams/groups/${teamGroup.id}`, teamGroup);
}

/**
 * useUpdateTeamGroup is a hook that updates a team group and invalidates the team groups query.
 */
export default function useUpdateTeamGroup(teamGroup: UpdateTeamGroupRequest) {
  return useMutation({
    mutationFn: () => updateTeamGroup(teamGroup),
    onSuccess: () => {
      // Update the cache
      queryClient.setQueryData(
        getTeamGroupQueryKey(teamGroup.id),
        (oldTeamGroup: TeamGroupResponse | undefined) => {
          if (!oldTeamGroup) {
            return undefined;
          }
          return {
            ...oldTeamGroup,
            ...teamGroup,
          };
        },
      );
      // Then we invalidate the team group query, so that the new full team group data is refetched.
      queryClient.invalidateQueries(getTeamGroupQueryKey(teamGroup.id));
    },
  });
}
